import { Box, Button, Grid, Typography } from "@mui/material";
import { useContext, useEffect, useState } from "react";

import { GlobalAlertContext } from "../../contexts/GlobalAlertContext";

import React from "react";
import CardSys from "../../components/cardSys";
import TitlePages from "../../components/generic/titlePages";
import ButtonSave from "../../components/buttonSave";
import { api } from "../../services/api";
import InputUserProfile from "../../components/generic/inputUserProfile";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../contexts/AuthContext";
import CancelButton from "../../components/generic/cancelButton";

export default function Profile() {

  const { handleLoading, handleToast } = useContext(GlobalAlertContext);

  const { user: userLogged, getUser } = useContext(AuthContext);
  const [user, setUser] = useState(userLogged?.name);
  useEffect(() => {
    setUser(userLogged?.name);
  }, [userLogged]);
  const enterpriseProfile = userLogged?.name_client;
  const emailProfile = userLogged?.email;

  const navigate = useNavigate();

  const handleUpdate = async (event) => {
    event.preventDefault();
    if (user == "") {
      handleToast(true, "error", "Digite o nome");
      return;
    }
    handleLoading(true);
    try {
      const { data } = await api({
        method: "PUT",
        url: "/user/" + userLogged?.id,
        data: {
          name: user,
        },
      });
      handleToast(true, data.toast, data.message);
    } catch (err) {
      handleToast(true, err.response.data.toast, err.response.data.message);
    }
    handleLoading(false);
    getUser()
  };
  return (
    <>
      <Grid container sx={{ marginBottom: "16px" }}>
        <Grid item>
          <TitlePages>Perfil</TitlePages>
        </Grid>
      </Grid>
      <CardSys>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
          <Grid
            item
            xs={4}
            direction="row"
            justifyContent="center"
            alignItems="center"
          >
            <Box>
              <Typography
              sx={{
                fontWeight:"bold",
                textAlign: "center"
              }}>
                {enterpriseProfile}
              </Typography>
            </Box>
          </Grid>
          <Grid
            item
            xs={12}
            sx={{ display: "flex", marginTop: "64px" }}
            direction="row"
            justifyContent="center"
            alignItems="center"
          ></Grid>
        </Grid>

        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
          <Grid
            item
            xs={4}
            direction="row"
            justifyContent="center"
            alignItems="center"
          >
            <InputUserProfile
              value={user}
              onChange={({ target }) => setUser(target.value)}
            ></InputUserProfile>
          </Grid>
        </Grid>

        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
          <Grid
            item
            sx={{ display: "flex", marginTop: "28px" }}
            xs={4}
            direction="row"
            justifyContent="center"
            alignItems="center"
          >
            <Box>
              <Typography sx={{color:"#909398"}}
              >
                {emailProfile}
              </Typography>
            </Box>
          </Grid>
        </Grid>
        <Grid
          container
          sx={{ marginTop: "48px", display: "flex", textTransform: "initial" }}
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
          <Grid item>
            <Button
              xs={5}
              color="blueSys"
              sx={{ textTransform: "initial", fontSize: "0.8rem" }}
              onClick={() => navigate("/editPassword")}
            >
              Trocar senha
            </Button>
          </Grid>
        </Grid>
        <Grid
          container
          sx={{ marginTop: "136px", display: "flex" }}
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
          <Grid item>
            <CancelButton onClick={() => navigate("/home")}></CancelButton>
          </Grid>
          <Grid item>
            <ButtonSave
              onClick={handleUpdate}
              sx={{
                borderRadius: "0.7rem",
                color: "white",
                textTransform: "initial",
              }}
            >Salvar</ButtonSave>
          </Grid>
        </Grid>
      </CardSys>
    </>
  );
}
